export const SITE_URL = "https://angiolini.kz";

export const ARTICLES_PART1 = [
  {
    slug: "italyanskie-shuby-pochemu-italiya",
    title: "Итальянские шубы: почему Италия — мировая столица мехового мастерства",
    seoTitle: "Итальянские шубы — почему Италия лидер мехового мастерства | Angiolini",
    description:
      "Чем итальянские шубы отличаются от всех остальных: история меховых ателье Италии, секреты выделки, крой и причины, по которым мех из Италии считается эталоном.",
    date: "2026-06-02",
    readTime: "6 мин",
    tag: "Италия",
    image: "/media/frame-1.jpg",
    sections: [
      {
        h: "Наследие, которому больше века",
        ps: [
          "Итальянское меховое ремесло зародилось в семейных мастерских Милана, Турина и Флоренции ещё в конце XIX века. Секреты выделки меха, кроя и посадки передавались из поколения в поколение — и именно эта преемственность сделала итальянские шубы эталоном качества во всём мире.",
          "Пока крупные фабрики гнались за объёмами, итальянские ателье сохраняли ручной труд. Каждая шуба проходит через руки мастера-скорняка десятки раз: подбор шкурок, раскрой, сборка, посадка, финишная отделка.",
        ],
      },
      {
        h: "Что отличает итальянскую шубу",
        ps: [
          "Первое — отбор сырья. Итальянские дома работают только с мехом высшей категории: соболь, норка, шиншилла и рысь проходят строгий аудит по густоте, блеску и равномерности окраса.",
          "Второе — крой. Итальянская школа ставит силуэт выше всего: шуба должна не просто греть, а строить фигуру. Лекала рассчитываются с точностью до миллиметра, а финальная примерка с подгонкой — обязательная часть работы.",
          "Третье — фурнитура и подкладка. Шёлк, застёжки ручной работы, невидимые швы — детали, которые не бросаются в глаза, но создают ощущение абсолютного люкса.",
        ],
      },
      {
        h: "Итальянские шубы в Казахстане",
        ps: [
          "Angiolini привозит итальянскую верхнюю одежду напрямую из ателье Италии в Алматы. В коллекции — шубы из соболя, норки и шиншиллы, кашемировые пальто и пуховики премиальных итальянских брендов.",
          "Посмотреть модели, актуальные цены и записаться на примерку можно в приложении Angiolini — регистрация занимает меньше минуты, а бонусы начисляются сразу.",
        ],
      },
    ],
  },
  {
    slug: "sobolinaya-shuba-kak-vybrat",
    title: "Соболь — король меха: как выбрать соболиную шубу",
    seoTitle: "Соболиная шуба: как выбрать мех соболя — гид эксперта | Angiolini",
    description:
      "Полный гид по выбору соболиной шубы: виды соболя, на что смотреть при покупке, как отличить баргузинский мех, сколько служит соболь и почему это лучшая инвестиция в гардероб.",
    date: "2026-06-05",
    readTime: "7 мин",
    tag: "Соболь",
    image: "/media/frame-4.jpg",
    sections: [
      {
        h: "Почему соболь называют королём меха",
        ps: [
          "Соболь — самый ценный промысловый мех в мире. Его отличает невероятная шелковистость, глубокий цвет с серебристой остью и лёгкость, которую невозможно спутать ни с чем. Соболиная шуба при должном уходе служит 15–20 сезонов, оставаясь роскошной.",
          "Самым дорогим считается баргузинский соболь — тёмный, почти шоколадный мех с густым подшёрстком и характерной «сединой». Именно его выбирают итальянские дома для лимитированных коллекций.",
        ],
      },
      {
        h: "На что смотреть при выборе",
        ps: [
          "Цвет: чем темнее и равномернее окрас, тем выше категория. Лёгкая серебристость ости — признак элитного меха, а не дефект.",
          "Мездра: кожа с обратной стороны должна быть светлой, мягкой и эластичной. Жёсткая или тёмная мездра говорит о старом или плохо выделанном мехе.",
          "Ворс: проведите рукой против роста — качественный соболь мгновенно возвращается в исходное положение и не оставляет заломов.",
          "Пошив: у хорошей шубы швы не прощупываются, а рисунок меха переходит от шкурки к шкурке без видимых границ.",
        ],
      },
      {
        h: "Соболь от Angiolini",
        ps: [
          "В коллекции Angiolini представлены соболиные шубы итальянского пошива — от классических длинных силуэтов до укороченных моделей с поясом. Каждая шуба сопровождается сертификатом происхождения меха.",
          "Откройте каталог в приложении Angiolini: там собраны все модели из соболя с ценами, размерами и возможностью виртуальной ИИ-примерки.",
        ],
      },
    ],
  },
  {
    slug: "norkovaya-shuba-gid-po-vyboru",
    title: "Норковая шуба: подробный гид по выбору в 2026 году",
    seoTitle: "Норковая шуба — как выбрать норку в 2026 году: гид | Angiolini",
    description:
      "Как выбрать норковую шубу: виды норки, скандинавская и североамериканская норка, модные фасоны 2026 года, проверка качества меха и советы итальянских скорняков.",
    date: "2026-06-08",
    readTime: "6 мин",
    tag: "Норка",
    image: "/media/frame-3.jpg",
    sections: [
      {
        h: "Какой бывает норка",
        ps: [
          "Скандинавская норка — самая распространённая в люксовом сегменте: густой подшёрсток, ровная ость, широкая палитра от жемчужного до чёрного бриллианта.",
          "Североамериканская норка ценится за низкий, бархатистый ворс — шубы из неё выглядят особенно графично и строго.",
          "Итальянские дома работают с аукционным мехом высших лотов: каждая партия проходит отбор по густоте, блеску и однородности тона.",
        ],
      },
      {
        h: "Проверяем качество за пять минут",
        ps: [
          "Сожмите мех в ладони и отпустите: качественная норка мгновенно восстанавливает форму. Подуйте на ворс — подшёрсток должен быть густым, без «просветов» до мездры.",
          "Обратите внимание на блеск: живой перелив при движении — признак здорового меха. Тусклый или чрезмерно «лаковый» блеск может говорить о перекрашивании.",
          "Вес имеет значение: хорошая норковая шуба ощущается легче, чем выглядит. Тяжесть — признак толстой мездры или некачественной выделки.",
        ],
      },
      {
        h: "Фасоны 2026 года",
        ps: [
          "В моде свободные силуэты: шубы-халаты с поясом, укороченные бомберы и модели oversize с рукавом три четверти. Итальянские дизайнеры делают ставку на естественные оттенки — графит, орех, сливочный.",
          "Все актуальные модели норковых шуб Angiolini — в приложении: фильтры по цвету, длине и размеру помогут найти свою модель за пару минут, а ИИ-примерка покажет, как она сядет именно на вас.",
        ],
      },
    ],
  },
  {
    slug: "mekh-shinshilly-samyy-nezhnyy",
    title: "Шиншилла: самый нежный мех в мире и как его носить",
    seoTitle: "Мех шиншиллы — шубы и жилеты из шиншиллы: гид | Angiolini",
    description:
      "Всё о мехе шиншиллы: почему он считается самым мягким в мире, как выбрать шубу из шиншиллы, правила ухода и с чем носить — советы итальянских стилистов.",
    date: "2026-06-11",
    readTime: "5 мин",
    tag: "Шиншилла",
    image: "/media/frame-6.jpg",
    sections: [
      {
        h: "Почему шиншилла вне конкуренции",
        ps: [
          "На одном квадратном сантиметре шкурки шиншиллы растёт до 25 000 волосков — больше, чем у любого другого пушного зверя. Отсюда — знаменитая невесомая мягкость, которую невозможно описать словами: её нужно почувствовать.",
          "Характерный окрас — жемчужно-серый с тёмной «вуалью» по хребту и светлым брюшком — создаёт естественный градиент, который итальянские скорняки превращают в графичные узоры на шубах и жилетах.",
        ],
      },
      {
        h: "Как выбирать и как ухаживать",
        ps: [
          "Мех шиншиллы деликатен: выбирайте изделия с плотной, эластичной мездрой и равномерным окрасом без желтизны. Швы должны быть тонкими и незаметными — грубая сборка мгновенно выдаёт кустарную работу.",
          "Шиншилла не любит влагу и трение: избегайте сумок на плечо и продолжительного дождя. Храните изделие в дышащем чехле, а летом отдавайте в профессиональное меховое хранилище.",
        ],
      },
      {
        h: "Шиншилла в коллекции Angiolini",
        ps: [
          "Angiolini привозит изделия из шиншиллы итальянского пошива: шубы, жакеты и воротники. Из-за деликатности меха тираж каждой модели ограничен — новинки быстрее всего появляются в приложении.",
          "Зарегистрируйтесь в клубе Angiolini, чтобы первыми узнавать о поступлениях шиншиллы и получить приветственные бонусы на покупку.",
        ],
      },
    ],
  },
  {
    slug: "kashemirovye-palto-iz-italii",
    title: "Кашемировые пальто из Италии: тепло без тяжести",
    seoTitle: "Итальянские кашемировые пальто — как выбрать кашемир | Angiolini",
    description:
      "Гид по итальянским кашемировым пальто: чем кашемир из Италии отличается от массмаркета, виды кашемира, как проверить качество и модные силуэты сезона.",
    date: "2026-06-14",
    readTime: "6 мин",
    tag: "Кашемир",
    image: "/media/frame-2.jpg",
    sections: [
      {
        h: "Итальянский кашемир — это другой кашемир",
        ps: [
          "Лучшие кашемировые фабрики мира находятся на севере Италии — в Пьемонте и Ломбардии. Именно там пух горных коз превращают в ткань, которая весит вдвое меньше шерсти, а греет заметно лучше.",
          "Разница с массмаркетом — в длине волокна: итальянские дома используют волокно от 36 мм, поэтому пальто не скатывается годами и с каждым сезоном становится только мягче.",
        ],
      },
      {
        h: "Как проверить качество кашемира",
        ps: [
          "Сожмите ткань в руке на несколько секунд: качественный кашемир почти не мнётся и быстро расправляется. Посмотрите на просвет — плотное полотно без «проплешин» говорит о высокой плотности вязки.",
          "Проведите ладонью по поверхности: у хорошего кашемира ворс ровный и шелковистый, без ощущения «мыльности», которое даёт дешёвое волокно с примесями.",
        ],
      },
      {
        h: "Силуэты сезона и где смотреть",
        ps: [
          "В этом сезоне итальянцы носят кашемир свободно: пальто-халаты, двубортные оверсайз-модели и монохромные тотал-луки в оттенках топлёного молока, верблюжьего и графитового.",
          "Кашемировые пальто Angiolini уже в каталоге приложения: смотрите состав, цены и наличие размеров, сохраняйте понравившиеся модели и записывайтесь на примерку в шоуруме в Алматы.",
        ],
      },
    ],
  },
];
